
import Header from '../components/Header'
import Footer from '../components/Footer'
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from 'react-lazyload';
const ComputerLab = () => {
    return(
        <>
            <Header/>
            <Breadcrumb pageTitle="Computer Lab" mid="Facilities" breadcrumbName="Computer Lab" />
            <div className='container facilities_img'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <h3 className="sub-title">Computer Lab</h3>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer1.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer1.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer2.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer2.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer3.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer3.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer4.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer4.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer5.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer5.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>

                    
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer6.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer6.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer7.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer7.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer8.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer8.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer9.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer9.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12'>
                        <div className='inner-img'>
                        <a data-magnify="gallery" data-src="" data-group="a" href='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer10.jpg'>
                            <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STHSM/public/Images/computer10.jpg' className='img-fluid' /></LazyLoad>
                            </a>
                        </div>
                    </div>

                     

                </div>
                 
            </div>
            <Footer />
        </>
    )
}
export default ComputerLab